(function ($) {
	RVwys.plugin['Icon'] = true;
	RVwys.AwesomeFont = new AwesomeFont();
	RVwys.AwesomeFontMenu = new AwesomeFontMenu();
	 var aSpacialVal = {};
//	 RVwys.plugin['indent'] = true;
	 aSpacialVal['&#33'] = 'exclamation mark';
	 aSpacialVal['&quot'] = 'double quotation mark';
	 aSpacialVal['&#35'] = 'number sign';
	 aSpacialVal['&#36'] = 'dollar sign';
	 aSpacialVal['&#37'] = 'percent sign';
	 aSpacialVal['&amp'] = 'ampersand';
	 aSpacialVal['&#39'] = 'apostrophe';
	 aSpacialVal['&#40'] = 'left parenthesis';
	 aSpacialVal['&#41'] = 'right parenthesis';
	 aSpacialVal['&#42'] = 'asterisk';
	 aSpacialVal['&#43'] = 'plus sign';
	 aSpacialVal['&#44'] = 'comma';
	 aSpacialVal['&#45'] = 'hyphen';
	 aSpacialVal['&#46'] = 'period';
	 aSpacialVal['&frasl'] = 'slash';

	 aSpacialVal['&#58'] = 'colon';
	 aSpacialVal['&#59'] = 'semicolon';
	 aSpacialVal['&lt'] = 'less-than sign';
	 aSpacialVal['&#61'] = 'equals sign';
	 aSpacialVal['&gt'] = 'greater-than sign';
	 aSpacialVal['&#63'] = 'question mark';
	 aSpacialVal['&#64'] = 'at sign';

	 aSpacialVal['&#91'] = 'left square bracket';
	 aSpacialVal['&#92'] = 'backslash';
	 aSpacialVal['&#93'] = 'right square bracket';
	 aSpacialVal['&#94'] = 'caret';
	 aSpacialVal['&#95'] = 'horizontal bar (underscore)';
	 aSpacialVal['&#96'] = 'grave accent';
	 aSpacialVal['&#48'] = 'digits 0';
	 aSpacialVal['&#49'] = 'digits 1';
	 aSpacialVal['&#50'] = 'digits 2';
	 aSpacialVal['&#51'] = 'digits 3';
	 aSpacialVal['&#52'] = 'digits 4';
	 aSpacialVal['&#53'] = 'digits 5';
	 aSpacialVal['&#54'] = 'digits 6';
	 aSpacialVal['&#55'] = 'digits 7';
	 aSpacialVal['&#56'] = 'digits 8';
	 aSpacialVal['&#57'] = 'digits 9';
	 aSpacialVal['&#65'] = 'uppercase-letters-A';
	 aSpacialVal['&#66'] = 'uppercase letters B';
	 aSpacialVal['&#67'] = 'uppercase letters C';
	 aSpacialVal['&#68'] = 'uppercase letters D';
	 aSpacialVal['&#69'] = 'uppercase letters E';
	 aSpacialVal['&#70'] = 'uppercase letters F';
	 aSpacialVal['&#71'] = 'uppercase letters G';
	 aSpacialVal['&#72'] = 'uppercase letters H';
	 aSpacialVal['&#73'] = 'uppercase letters I';
	 aSpacialVal['&#74'] = 'uppercase letters J';
	 aSpacialVal['&#75'] = 'uppercase letters K';
	 aSpacialVal['&#76'] = 'uppercase letters L';
	 aSpacialVal['&#77'] = 'uppercase letters M';
	 aSpacialVal['&#78'] = 'uppercase letters N';
	 aSpacialVal['&#79'] = 'uppercase letters O';
	 aSpacialVal['&#80'] = 'uppercase letters P';
	 aSpacialVal['&#81'] = 'uppercase letters Q';
	 aSpacialVal['&#82'] = 'uppercase letters R';
	 aSpacialVal['&#83'] = 'uppercase letters S';
	 aSpacialVal['&#84'] = 'uppercase letters T';
	 aSpacialVal['&#85'] = 'uppercase letters U';
	 aSpacialVal['&#86'] = 'uppercase letters V';
	 aSpacialVal['&#87'] = 'uppercase letters W';
	 aSpacialVal['&#88'] = 'uppercase letters X';
	 aSpacialVal['&#89'] = 'uppercase letters Y';
	 aSpacialVal['&#90'] = 'uppercase letters Z';
	 aSpacialVal['&#97'] = 'uppercase letters a';
	 aSpacialVal['&#98'] = 'uppercase letters b';
	 aSpacialVal['&#99'] = 'uppercase letters c';
	 aSpacialVal['&#100'] = 'uppercase letters d';
	 aSpacialVal['&#101'] = 'uppercase letters e';
	 aSpacialVal['&#102'] = 'uppercase letters f';
	 aSpacialVal['&#103'] = 'uppercase letters g';
	 aSpacialVal['&#104'] = 'uppercase letters h';
	 aSpacialVal['&#105'] = 'uppercase letters i';
	 aSpacialVal['&#106'] = 'uppercase letters j';
	 aSpacialVal['&#107'] = 'uppercase letters k';
	 aSpacialVal['&#108'] = 'uppercase letters l';
	 aSpacialVal['&#109'] = 'uppercase letters m';
	 aSpacialVal['&#110'] = 'uppercase letters n';
	 aSpacialVal['&#111'] = 'uppercase letters o';
	 aSpacialVal['&#112'] = 'uppercase letters p';
	 aSpacialVal['&#113'] = 'uppercase letters q';
	 aSpacialVal['&#114'] = 'uppercase letters r';
	 aSpacialVal['&#115'] = 'uppercase letters s';
	 aSpacialVal['&#116'] = 'uppercase letters t';
	 aSpacialVal['&#117'] = 'uppercase letters u';
	 aSpacialVal['&#118'] = 'uppercase letters v';
	 aSpacialVal['&#119'] = 'uppercase letters w';
	 aSpacialVal['&#120'] = 'uppercase letters x';
	 aSpacialVal['&#121'] = 'uppercase letters y';
	 aSpacialVal['&#122'] = 'uppercase letters z';
	 aSpacialVal['&#123'] = 'left curly brace';
	 aSpacialVal['&#124'] = 'vertical bar';
	 aSpacialVal['&#125'] = 'right curly brace';

	 aSpacialVal['&acute'] = 'acute accent';
	 aSpacialVal['&micro'] = 'micro sign';
	 aSpacialVal['&para'] = 'paragraph sign';
	 aSpacialVal['&middot'] = 'middle dot';
	 aSpacialVal['&cedil'] = 'cedilla';
	 aSpacialVal['&ordm'] = 'masculine ordinal';
	 aSpacialVal['&raquo'] = 'right angle quote';
	 aSpacialVal['&frac14'] = 'one-fourth';
	 aSpacialVal['&frac12'] = 'one-half';
	 aSpacialVal['&frac34'] = 'three-fourths';
	 aSpacialVal['&iquest'] = 'inverted question mark';
	 aSpacialVal['&Agrave'] = 'uppercase A, grave accent';
	 aSpacialVal['&Aacute'] = 'uppercase A, acute accent';
	 aSpacialVal['&Acirc'] = 'uppercase A, circumflex accent';
	 aSpacialVal['&Atilde'] = 'uppercase A, tilde';
	 aSpacialVal['&Auml'] = 'uppercase A, umlaut';
	 aSpacialVal['&Aring'] = 'uppercase A, ring';
	 aSpacialVal['&AElig'] = 'uppercase AE';
	 aSpacialVal['&Ccedil'] = 'uppercase C, cedilla';
	 aSpacialVal['&Egrave'] = 'uppercase E, grave accent';
	 aSpacialVal['&Eacute'] = 'uppercase E, acute accent';
	 aSpacialVal['&Ecirc'] = 'uppercase E, circumflex accent';
	 aSpacialVal['&Euml'] = 'uppercase E, umlaut';
	 aSpacialVal['&Igrave'] = 'uppercase I, grave accent';
	 aSpacialVal['&Iacute'] = 'uppercase I, acute accent';
	 aSpacialVal['&Icirc'] = 'uppercase I, circumflex accent';
	 aSpacialVal['&Iuml'] = 'uppercase I, umlaut';
	 aSpacialVal['&ETH'] = 'uppercase Eth, Icelandic';
	 aSpacialVal['&Ntilde'] = 'uppercase N, tilde';
	 aSpacialVal['&Ograve'] = 'uppercase O, grave accent';
	 aSpacialVal['&Oacute'] = 'uppercase O, acute accent';
	 aSpacialVal['&Ocirc'] = 'uppercase O, circumflex accent';
	 aSpacialVal['&Otilde'] = 'uppercase O, tilde';
	 aSpacialVal['&Ouml'] = 'uppercase O, umlaut';
	 aSpacialVal['&times'] = 'multiplication sign';
	 aSpacialVal['&Oslash'] = 'uppercase O, slash';
	 aSpacialVal['&Ugrave'] = 'uppercase U, grave accent';
	 aSpacialVal['&Uacute'] = 'uppercase U, acute accent';
	 aSpacialVal['&Ucirc'] = 'uppercase U, circumflex accent';
	 aSpacialVal['&Uuml'] = 'uppercase U, umlaut';
	 aSpacialVal['&Yacute'] = 'uppercase Y, acute accent';
	 aSpacialVal['&THORN'] = 'uppercase THORN, Icelandic';
	 aSpacialVal['&szlig'] = 'lowercase sharps, German';
	 aSpacialVal['&agrave'] = 'lowercase a, grave accent';
	 aSpacialVal['&aacute'] = 'lowercase a, acute accent';
	 aSpacialVal['&acirc'] = 'lowercase a, circumflex accent';
	 aSpacialVal['&atilde'] = 'lowercase a, tilde';
	 aSpacialVal['&auml'] = 'lowercase a, umlaut';
	 aSpacialVal['&aring'] = 'lowercase a, ring';
	 aSpacialVal['&aelig'] = 'lowercase ae';
	 aSpacialVal['&ccedil'] = 'lowercase c, cedilla';
	 aSpacialVal['&egrave'] = 'lowercase e, grave accent';
	 aSpacialVal['&eacute'] = 'lowercase e, acute accent';
	 aSpacialVal['&ecirc'] = 'lowercase e, circumflex accent';
	 aSpacialVal['&euml'] = 'lowercase e, umlaut';
	 aSpacialVal['&igrave'] = 'lowercase i, grave accent';
	 aSpacialVal['&iacute'] = 'lowercase i, acute accent';
	 aSpacialVal['&icirc'] = 'lowercase i, circumflex accent';
	 aSpacialVal['&iuml'] = 'lowercase i, umlaut';
	 aSpacialVal['&eth'] = 'lowercase eth, Icelandic';
	 aSpacialVal['&ntilde'] = 'lowercase n, tilde';
	 aSpacialVal['&ograve'] = 'lowercase o, grave accent';
	 aSpacialVal['&oacute'] = 'lowercase o, acute accent';
	 aSpacialVal['&ocirc'] = 'lowercase o, circumflex accent';
	 aSpacialVal['&otilde'] = 'lowercase o, tilde';
	 aSpacialVal['&ouml'] = 'lowercase o, umlaut';
	 aSpacialVal['&divide'] = 'division sign';
	 aSpacialVal['&oslash'] = 'lowercase o, slash';
	 aSpacialVal['&ugrave'] = 'lowercase u, grave accent';
	 aSpacialVal['&uacute'] = 'lowercase u, acute accent';
	 aSpacialVal['&ucirc'] = 'lowercase u, circumflex accent';
	 aSpacialVal['&uuml'] = 'lowercase u, umlaut';
	 aSpacialVal['&yacute'] = 'lowercase y, acute accent';
	 aSpacialVal['&thorn'] = 'lowercase thorn, Icelandic';
	 aSpacialVal['&yuml'] = 'lowercase y, umlaut';
	 aSpacialVal['&Alpha'] = 'Alpha';
	 aSpacialVal['&alpha'] = 'alpha';
	 aSpacialVal['&Beta'] = 'Beta';
	 aSpacialVal['&beta'] = 'beta';
	 aSpacialVal['&Gamma'] = 'Gamma';
	 aSpacialVal['&gamma'] = 'gamma';
	 aSpacialVal['&Delta'] = 'Delta';
	 aSpacialVal['&delta'] = 'delta';
	 aSpacialVal['&Epsilon'] = 'Epsilon';
	 aSpacialVal['&epsilon'] = 'epsilon';
	 aSpacialVal['&Zeta'] = 'Zeta';
	 aSpacialVal['&zeta'] = 'zeta';
	 aSpacialVal['&Eta'] = 'Eta';
	 aSpacialVal['&eta'] = 'eta';
	 aSpacialVal['&Theta'] = 'Theta';
	 aSpacialVal['&theta'] = 'theta';
	 aSpacialVal['&Iota'] = 'Iota';
	 aSpacialVal['&iota'] = 'iota';
	 aSpacialVal['&Kappa'] = 'Kappa';
	 aSpacialVal['&kappa'] = 'kappa';
	 aSpacialVal['&Lambda'] = 'Lambda';
	 aSpacialVal['&lambda'] = 'lambda';
	 aSpacialVal['&Mu'] = 'Mu';
	 aSpacialVal['&mu'] = 'mu';
	 aSpacialVal['&Nu'] = 'Nu';
	 aSpacialVal['&nu'] = 'nu';
	 aSpacialVal['&Xi'] = 'Xi';
	 aSpacialVal['&xi'] = 'xi';
	 aSpacialVal['&Omicron'] = 'Omicron';
	 aSpacialVal['&omicron'] = 'omicron';
	 aSpacialVal['&Pi'] = 'Pi';
	 aSpacialVal['&pi'] = 'pi';
	 aSpacialVal['&Rho'] = 'Rho';
	 aSpacialVal['&rho'] = 'rho';
	 aSpacialVal['&Sigma'] = 'Sigma';
	 aSpacialVal['&sigma'] = 'sigma';
	 aSpacialVal['&Tau'] = 'Tau';
	 aSpacialVal['&tau'] = 'tau';
	 aSpacialVal['&Upsilon'] = 'Upsilon';
	 aSpacialVal['&upsilon'] = 'upsilon';
	 aSpacialVal['&Phi'] = 'Phi';
	 aSpacialVal['&phi'] = 'phi';
	 aSpacialVal['&Chi'] = 'Chi';
	 aSpacialVal['&chi'] = 'chi';
	 aSpacialVal['&Psi'] = 'Psi';
	 aSpacialVal['&psi'] = 'psi';
	 aSpacialVal['&Omega'] = 'Omega';
	 aSpacialVal['&omega'] = 'omega';
	 aSpacialVal['&#9679'] = 'password dot';
	 aSpacialVal['&#126'] = 'tilde';
	 aSpacialVal['&hellip'] = 'ellipses';
	 aSpacialVal['&ndash'] = 'en dash';
	 aSpacialVal['&mdash'] = 'em dash';
	 aSpacialVal['&#152'] = 'unused';
	 aSpacialVal['&#153'] = 'unused';
	 aSpacialVal['&#154'] = 'unused';
	 aSpacialVal['&#155'] = 'unused';
	 aSpacialVal['&#156'] = 'unused';
	 aSpacialVal['&#157'] = 'unused';
	 aSpacialVal['&#158'] = 'unused';
	 aSpacialVal['&#159'] = 'unused';
	 aSpacialVal['&lsquo'] = 'left single quote';
	 aSpacialVal['&rsquo'] = 'right single quote';
	 aSpacialVal['&sbquo'] = 'single low-9 quote';
	 aSpacialVal['&ldquo'] = 'left double quote';
	 aSpacialVal['&rdquo'] = 'right double quote';
	 aSpacialVal['&bdquo'] = 'double low-9 quote';
	 aSpacialVal['&dagger'] = 'dagger';
	 aSpacialVal['&Dagger'] = 'double dagger';
	 aSpacialVal['&permil'] = 'per mill sign';
	 aSpacialVal['&lsaquo'] = 'single left-pointing angle quote';
	 aSpacialVal['&rsaquo'] = 'single right-pointing angle quote';

	 aSpacialVal['&oline'] = 'overline, = spacing overscore';
	 aSpacialVal['&larr'] = 'leftward arrow';
	 aSpacialVal['&uarr'] = 'upward arrow';
	 aSpacialVal['&rarr'] = 'rightward arrow';
	 aSpacialVal['&darr'] = 'downward arrow';
	 aSpacialVal['&trade'] = 'trademark sign';
	 aSpacialVal['&nbsp'] = 'nonbreaking space';
	 aSpacialVal['&iexcl'] = 'inverted exclamation';
	 aSpacialVal['&cent'] = 'cent sign';
	 aSpacialVal['&pound'] = 'pound sterling';
	 aSpacialVal['&curren'] = 'general currency sign';
	 aSpacialVal['&yen'] = 'yen sign';
	 aSpacialVal['&brvbar'] = 'broken vertical bar';
	 aSpacialVal['&sect'] = 'section sign';
	 aSpacialVal['&uml'] = 'umlaut';
	 aSpacialVal['&die'] = 'umlaut';
	 aSpacialVal['&copy'] = 'copyright';
	 aSpacialVal['&ordf'] = 'feminine ordinal';
	 aSpacialVal['&laquo'] = 'left angle quote';
	 aSpacialVal['&not'] = 'not sign';
	 aSpacialVal['&shy'] = 'soft hyphen';
	 aSpacialVal['&reg'] = 'registered trademark';
	 aSpacialVal['&macr'] = 'macron accent';
	 aSpacialVal['&deg'] = 'degree sign';
	 aSpacialVal['&plusmn'] = 'plus or minus';
	 aSpacialVal['&sup1'] = 'superscript one';
	 aSpacialVal['&sup2'] = 'superscript two';
	 aSpacialVal['&sup3'] = 'superscript three';
	 aSpacialVal['&#8226'] = 'bullet';
	 aSpacialVal['&spades'] = 'black spade suit';
	 aSpacialVal['&clubs'] = 'black club suit';
	 aSpacialVal['&hearts'] = 'black heart suit';
	 aSpacialVal['&diams'] = 'black diamond suit';
	 
	 function AwesomeFont(){
		 
		this.getIconAwesomeFont;
		this.getColorAwesomeFont;
		this.getSizeAwesomeFont;
		 
		this.openDialogAwesomeFont = function(){
			//alert(this.dialogAwesomeFont.get(0))
			var cloneRange = RVwys.getRange();
			 var UI = UIkit;
			var onInsert = function(){
					RVwys.AwesomeFont.insertAwesomeFontToWys();
					modalf.hide();
				};
				var oncancel  = function(){
					modalf.hide();
				};
				var options   = {
						bgclose:false, 
						keyboard:false, 
						modal:false
						};
				
				var  modalf = UI.modal.dialog(([
				                              '<div class="uk-margin uk-modal-header"><h2>'+rvLang('AwesomeFont')+'</h2><span class="uk-modal-close uk-icon-close"></span></div>',
				                              '<div class="uk-margin uk-modal-content">'+$('.awesomefontDialog-form').html()+'</div>',
				                              '<div class="uk-modal-footer uk-text-left">',
				                              '<button class="uk-button uk-button-success  js-modal-confirm">'+rvLang('Insert')+'</button>',
				                              '<button class="uk-button js-modal-confirm-cancel">'+rvLang('Cancel')+'</button>',
				                             // $('.awfontTool').html(),
				                              '</div>',
				                              ]).join(""), options);
				
				modalf.element.find("#setIconColor")
				.spectrum({
				    showInput: true,
				    allowEmpty:true,
				    preferredFormat: "hex",
				    beforeShow: function () {
						   var overlaypanel = $('<div class="overlaypanel"></div>').css({
							   'background-color':'red',
							   'opacity':'0.0',
							   'position':'absolute',
							   'left':'0px',
							   'top':'0px',
							   'width':$('body').width(),
							   'height':$('body').height()
						   });
						   parent.$('body').prepend(overlaypanel);
						   parent.$(document).bind("click.spectrum", function(){

									//alert(tinycolor.getOriginalInput)
									$("#set-blockProperties").spectrum("revert");
									//clickout();
									
								});
				    },
				    move: function(color) {
				    	
						 RVwys.AwesomeFont.getColorAwesomeFont = color;
						 $(this).hide();
						 RVwys.AwesomeFont.getSelectToView();
				    },

				    hide:function(color){
				    	
						 RVwys.AwesomeFont.getColorAwesomeFont = color;
						 $(this).hide();
						 RVwys.AwesomeFont.getSelectToView();
						 // clear getColorAwesomeFont ='##'
						 RVwys.AwesomeFont.getColorAwesomeFont = color;
				    	parent.$('.overlaypanel').remove();
				    	parent.$(document).unbind("click.spectrum");
				    }
				});
				
				modalf.element.find(".js-modal-confirm-cancel").on("click", function(){
					 oncancel();
					
				}).end().find(".uk-button-success").on("click", function(){
					onInsert();
					
				}).end().find('.specialcharBlockSize').on("mouseup", function(){
					RVwys.selectRange(cloneRange);
					$(RVwys.currentIframe).focus();
					modalf.element.find('#specialDisplay').html($(this).html());
					modalf.element.find('#spcCode').val($(this).attr('code'));
				})
			 RVwys.AwesomeFont.dialogAwesomeFont = modalf.element.find("#awesomefontDialog");
			 RVwys.AwesomeFont.iconAwesomeFont = modalf.element.find("#awesomefontDialog").find("i");
			// RVwys.AwesomeFont.insertAwesomeFont = modalf.element.find("#awesomefontInsert");
			 RVwys.AwesomeFont.closeAwesomeFont = modalf.element.find("#awesomefontClose");
			 RVwys.AwesomeFont.adjustSize = modalf.element.find("#adjustSizeAwesomefont");
			 RVwys.AwesomeFont.adjustColor = modalf.element.find('#awesomeFontColor');
			 RVwys.AwesomeFont.getViewAwesomeFont = modalf.element.find('.viewAwesomeFont');
			 RVwys.AwesomeFont.handleEventAwesomeFont();	 
			 modalf.show();
			 /*
			this.dialogAwesomeFont.dialog({
				 open:'true',
				 title:'AwesomeFont',
				 width:'800',
				 height:'550',
				modal:true
			 });
			 */
		};	
		
		this.choseAwesomeFont = function(icon){
			RVwys.AwesomeFont.iconAwesomeFont.css("border","solid #ffffff 1px");
			this.getIconAwesomeFont = icon.attr("class").split(" ")[0];
			icon.css("border","solid #5ac4e6 1px");
			this.getSelectToView();
		};
		
		this.changeSizeAwesomeFont = function(Size){
			this.getSizeAwesomeFont = Size;
			this.getSelectToView();
		};
		
		this.chooseColorAwesomeFont = function(ButtonColor){
			 var offset = ButtonColor.offset();
			 var objColorpicker =  $('#colorpickerTool');
			 objColorpicker.offset({ top: offset.top+ButtonColor.height()- 210, left: offset.left});
			 
			 objColorpicker.toggle(!objColorpicker.is(':visible'));
			 
			 $('#colorpickerToolCancel').val('cancel');
			 $.fn.colorPickerInsert = function(color){
				 RVwys.AwesomeFont.adjustColor.css('background-color', '#'+color);
				 RVwys.AwesomeFont.getColorAwesomeFont = '#'+color;
				 $(this).hide();
				 RVwys.AwesomeFont.getSelectToView();
			 };
		};
		
		this.getSelectToView = function(){
			if(this.getIconAwesomeFont){
				console.log('update->'+this.getColorAwesomeFont)
				var tagAwesomeFont = $('<i></i>').addClass(String(this.getIconAwesomeFont)).css({'color':String(this.getColorAwesomeFont)}).addClass(String(this.getSizeAwesomeFont));
				this.getViewAwesomeFont.html(tagAwesomeFont);
			}
		}
		
		this.getSelection = function(){
			if (window.getSelection){ 
				var getIframe = document.getElementById('frameBody');
				if(getIframe){
					getIframe = getIframe.contentWindow || getIframe.contentDocument;
					return getIframe.getSelection();
				} 
			}else if(document.selection && document.selection.createRange && document.selection.type != "None"){
				// for ie
				return document.selection.createRange();
			}
		}
		
		this.handleEventAwesomeFont = function(){

			 
			 //insert AwesomeFont
			 this.insertAwesomeFont.click(function(){
				 RVwys.AwesomeFont.insertAwesomeFontToWys();
			 });
			 
			 //change size AwesomeFont
			 this.adjustSize.change(function(){
				 RVwys.AwesomeFont.changeSizeAwesomeFont($(this).val());
			 });
			 
			//choose icon AwesomeFont
			 this.iconAwesomeFont.click(function(){
				 RVwys.AwesomeFont.choseAwesomeFont($(this));
			 });
			 
			 //choose color AwesomeFont
			 this.adjustColor.click(function(){
				 RVwys.AwesomeFont.chooseColorAwesomeFont($(this));
			 });
		}
		
		this.clearViewAwesomeFont = function(){
			this.getViewAwesomeFont.html('View');
			this.getSizeAwesomeFont = '';
			this.getColorAwesomeFont = '';
			this.iconAwesomeFont.css("border","solid #ffffff 1px");
			this.adjustSize.val("uk-icon-small");
		}
		
		this.insertAwesomeFontToWys = function(){
			/*
			var getObj = this.getSelection(), newElement, getRange;
			getRange = getObj.getRangeAt(0);
			
			// create tag for wrap
			newElement= document.createElement("i");
			
			// add the attribute to the new element
			$(newElement).addClass(this.getIconAwesomeFont).css('color', this.getColorAwesomeFont);
			$(newElement).addClass(this.getSizeAwesomeFont);
			
			getRange.insertNode(newElement);
			//getObj.removeAllRanges();
			this.clearViewAwesomeFont();
			
			
			
			*/
			RVwys.insertHTML($('<hr class="clearhr '+ String(this.getIconAwesomeFont || '') +' '+String(this.getSizeAwesomeFont || '')+' " style="color:'+String(this.getColorAwesomeFont || '')+';"/>'));
			//this.dialogAwesomeFont.dialog("close");
		};
	 }
	 	 
	 
//	 AwesomeFontMenu
	 function AwesomeFontMenu(){
		 
			this.getIconAwesomeFont;
			this.getColorAwesomeFont;
			this.getSizeAwesomeFont;
			 
			this.openDialogAwesomeFont = function(){
				//alert(this.dialogAwesomeFont.get(0))
				var cloneRange = RVwys.getRange();
				 var UI = UIkit;
					var onInsert = function(){
						RVwys.AwesomeFontMenu.insertAwesomeFontToWys();
						modalf.hide();
					};
					var oncancel  = function(){
						RVwys.AwesomeFontMenu.CancelAwesomeFontToWys();
						modalf.hide();
					};
					var options   = {
							bgclose:false, 
							keyboard:false, 
							modal:false
							};
					
					var  modalf = UI.modal.dialog(([
					                              '<div class="uk-margin uk-modal-header"><h2>'+rvLang('AwesomeFont')+'</h2><span class="uk-modal-close uk-icon-close"></span></div>',
					                              '<div class="uk-margin uk-modal-content">'+$('.awesomefontMenuDialog-form').html()+'</div>',
					                              '<div class="uk-modal-footer uk-text-left">',
					                              '<button class="uk-button uk-button-success  js-modal-confirm">'+rvLang('Select')+'</button>',
					                              '<button class="uk-button js-modal-confirm-cancel">'+rvLang('Cancel')+'</button>',
					                             // $('.awfontTool').html(),
					                              '</div>',
					                              ]).join(""), options);
					
					modalf.element.find("#setIconColor")
					.spectrum({
					    showInput: true,
					    allowEmpty:true,
					    preferredFormat: "hex",
					    beforeShow: function () {
							   var overlaypanel = $('<div class="overlaypanel"></div>').css({
								   'background-color':'red',
								   'opacity':'0.0',
								   'position':'absolute',
								   'left':'0px',
								   'top':'0px',
								   'width':$('body').width(),
								   'height':$('body').height()
							   });
							   parent.$('body').prepend(overlaypanel);
							   parent.$(document).bind("click.spectrum", function(){

										//alert(tinycolor.getOriginalInput)
										$("#set-blockProperties").spectrum("revert");
										//clickout();
										
									});
					    },
					    move: function(color) {
					    	
							 RVwys.AwesomeFontMenu.getColorAwesomeFont = color;
							 $(this).hide();
							 RVwys.AwesomeFontMenu.getSelectToView();
					    },

					    hide:function(color){
					    	
							 RVwys.AwesomeFontMenu.getColorAwesomeFont = color;
							 $(this).hide();
							 RVwys.AwesomeFontMenu.getSelectToView();
							 // clear getColorAwesomeFont ='##'
							 RVwys.AwesomeFontMenu.getColorAwesomeFont = color;
					    	parent.$('.overlaypanel').remove();
					    	parent.$(document).unbind("click.spectrum");
					    }
					});
					
					modalf.element.find(".js-modal-confirm-cancel").on("click", function(){
						 oncancel();
						
					}).end().find(".uk-button-success").on("click", function(){
						onInsert();
						
					}).end().find('.specialcharBlockSize').on("mouseup", function(){
						RVwys.selectRange(cloneRange);
						$(RVwys.currentIframe).focus();
						modalf.element.find('#specialDisplay').html($(this).html());
						modalf.element.find('#spcCode').val($(this).attr('code'));
					})
				 RVwys.AwesomeFontMenu.dialogAwesomeFont = modalf.element.find("#awesomefontDialogMenu");
				 RVwys.AwesomeFontMenu.iconAwesomeFont = modalf.element.find("#awesomefontDialogMenu").find("i");
				// RVwys.AwesomeFont.insertAwesomeFont = modalf.element.find("#awesomefontInsert");
				 RVwys.AwesomeFontMenu.closeAwesomeFont = modalf.element.find("#awesomefontCloseMenu");
				 RVwys.AwesomeFontMenu.adjustSize = modalf.element.find("#adjustSizeAwesomeFontMenu");
				 RVwys.AwesomeFontMenu.adjustColor = modalf.element.find('#awesomeFontColorMenu');
				 RVwys.AwesomeFontMenu.getViewAwesomeFont = modalf.element.find('.viewAwesomeFontMenu');

				 RVwys.AwesomeFontMenu.handleEventAwesomeFont();	 
				 modalf.show();
				 /*
				this.dialogAwesomeFont.dialog({
					 open:'true',
					 title:'AwesomeFont',
					 width:'800',
					 height:'550',
					modal:true
				 });
				 */
			};	
			
			this.choseAwesomeFont = function(icon){
				RVwys.AwesomeFontMenu.iconAwesomeFont.css("border","solid #ffffff 1px");
				this.getIconAwesomeFont = icon.attr("class").split(" ")[0];
				icon.css("border","solid #5ac4e6 1px");
				this.getSelectToView();
			};
			
			this.changeSizeAwesomeFont = function(Size){
				this.getSizeAwesomeFont = Size;
				this.getSelectToView();
			};
			
			this.chooseColorAwesomeFont = function(ButtonColor){
				 var offset = ButtonColor.offset();
				 var objColorpicker =  $('#colorpickerTool');
				 objColorpicker.offset({ top: offset.top+ButtonColor.height()- 210, left: offset.left});
		
				 objColorpicker.toggle(!objColorpicker.is(':visible'));
				 $('#colorpickerToolCancel').val('cancel');
				 $.fn.colorPickerInsert = function(color){
					 RVwys.AwesomeFontMenu.adjustColor.css('background-color', '#'+color);
					 RVwys.AwesomeFontMenu.getColorAwesomeFont = '#'+color;
					 $(this).hide();
					 RVwys.AwesomeFontMenu.getSelectToView();
				 };
			};
			
			this.getSelectToView = function(){
				if(this.getIconAwesomeFont){
					console.log('update->'+this.getColorAwesomeFont)
					var tagAwesomeFont = $('<i></i>').addClass(String(this.getIconAwesomeFont)).css({'color':String(this.getColorAwesomeFont)}).addClass(String(this.getSizeAwesomeFont));
					this.getViewAwesomeFont.html(tagAwesomeFont);
				}
			}
			
			this.getSelection = function(){
				if (window.getSelection){ 
					var getIframe = document.getElementById('frameBody');
					if(getIframe){
						getIframe = getIframe.contentWindow || getIframe.contentDocument;
						return getIframe.getSelection();
					} 
				}else if(document.selection && document.selection.createRange && document.selection.type != "None"){
					// for ie
					return document.selection.createRange();
				}
			}
			
			this.handleEventAwesomeFont = function(){

				 
				 //insert AwesomeFont
				 this.insertAwesomeFont.click(function(){
					 RVwys.AwesomeFontMenu.insertAwesomeFontToWys();
				 });
				 
				 //change size AwesomeFont
				 this.adjustSize.change(function(){
					 RVwys.AwesomeFontMenu.changeSizeAwesomeFont($(this).val());
				 });
				 
				//choose icon AwesomeFont
				 this.iconAwesomeFont.click(function(){
					 RVwys.AwesomeFontMenu.choseAwesomeFont($(this));
				 });
				 
				 //choose color AwesomeFont
				 this.adjustColor.click(function(){
					 RVwys.AwesomeFontMenu.chooseColorAwesomeFont($(this));
				 });
			}
			
			this.clearViewAwesomeFont = function(){
				this.getViewAwesomeFont.html('View');
				this.getSizeAwesomeFont = '';
				this.getColorAwesomeFont = '';
				this.iconAwesomeFont.css("border","solid #ffffff 1px");
				this.adjustSize.val("uk-icon-small");
			}
			
			this.insertAwesomeFontToWys = function(){
				
				var ClassIcon = $('#ViewIconMenu').attr("class").split(" ")[0];
				$('#ViewIconMenu').removeClass(ClassIcon).addClass(String(this.getIconAwesomeFont || ''));
				var icon = String(this.getIconAwesomeFont || '');
				RVwys.UpdateIcon(icon);
				
//				($('<hr class="clearhr '+ String(this.getIconAwesomeFont || '') +' '+String(this.getSizeAwesomeFont || '')+' " style="color:'+String(this.getColorAwesomeFont || '')+';"/>'));
				//this.dialogAwesomeFont.dialog("close");
			};
			
			this.CancelAwesomeFontToWys = function(){
				$('.parentAwesomeFontMenu').empty();
			};
			
		 }
	 
	 RVwys.designViewAddEvent('keydown',function(e){
		 $('.layoutSelect').remove();
	 });
	 
	 RVwys.designViewAddEvent('mousedown',function(e){
		 
	 });
	 
	 $(document).bind('editorReady',function(){

		 RVwys.AwesomeFont.dialogAwesomeFont = $("#awesomefontDialog");
		 RVwys.AwesomeFont.iconAwesomeFont = $("#awesomefontDialog").find("i");
		 RVwys.AwesomeFont.openAwesomeFont = $(".AwesomeFont");
		 RVwys.AwesomeFont.insertAwesomeFont = $("#awesomefontInsert");
		 RVwys.AwesomeFont.closeAwesomeFont = $("#awesomefontClose");
		 RVwys.AwesomeFont.adjustSize = $("#adjustSizeAwesomefont");
		 RVwys.AwesomeFont.adjustColor = $('#awesomeFontColor');
		 RVwys.AwesomeFont.getViewAwesomeFont = $('.viewAwesomeFont');
		 
			//open Dialog AwesomeFont
		 RVwys.AwesomeFont.openAwesomeFont.click(function(){
			 RVwys.AwesomeFont.openDialogAwesomeFont();
		 });
		 
		 RVwys.AwesomeFont.handleEventAwesomeFont();	 
		 
		 RVwys.AwesomeFontMenu.dialogAwesomeFont = $("#awesomefontDialogMenu");
		 RVwys.AwesomeFontMenu.iconAwesomeFont = $("#awesomefontDialogMenu").find("i");
		 RVwys.AwesomeFontMenu.openAwesomeFont = $(".AwesomeFontMenu");
		 RVwys.AwesomeFontMenu.insertAwesomeFont = $("#awesomefontInsertMenu");
		 RVwys.AwesomeFontMenu.closeAwesomeFont = $("#awesomefontCloseMenu");
		 RVwys.AwesomeFontMenu.adjustSize = $("#adjustSizeAwesomeFontMenu");
		 RVwys.AwesomeFontMenu.adjustColor = $('#awesomeFontColorMenu');
		 RVwys.AwesomeFontMenu.getViewAwesomeFont = $('.viewAwesomeFontMenu');
		 
			//open Dialog AwesomeFont
		 RVwys.AwesomeFontMenu.openAwesomeFont.click(function(){
			 var ViewIcon = $('.parentAwesomeFont').clone().html();
			 parent.$('.parentAwesomeFontMenu').append(ViewIcon);
			 RVwys.AwesomeFontMenu.openDialogAwesomeFont();
		 });
		 
		 RVwys.AwesomeFontMenu.handleEventAwesomeFont();	 

//	specialchar
		 $('.specialchar').click(function(){
			 	var cloneRange = RVwys.getRange();
			 	$(RVwys.currentIframe).focus();
				 var specialBlock = $('#specialBlock');
				 var html = '<div style="background:transparent; height:80%;"><div id="specialDisplay" class="specialDisplay">'+rvLang('view')+'</div>';
				 $.each(aSpacialVal,function(key, val){
					 html+='<div class="specialcharBlock"><a class="specialcharBlockSize" title = "'+val+'" href="javascript:void(0);" code ="'+ key.replace('&','&amp;') +';">' + key + ';</a></div>'
				 });
				 //html += '</div><div style="background:transparent;"><input id="spcCode" value="" style="border:#cccccc solid 1px; height:28px; padding-left:5px; margin-right:5px;"><button id="spcInsert" class="dialog-btn-input"><lang>'+rvLang('Insert')+'</lang></button><button id="spcCancel" class="dialog-btn-cancel">'+rvLang('Cancel')+'</button></div>';
				if(!$('#spc').get(0)) {
					var spc = $('<div id="spc">'+ html +'</div>');

				} else {
					var spc = $('#spc');
				}
				var UI = UIkit;
				var onInsert = function(){
					RVwys.selectRange(cloneRange);
					 if (cloneRange) {
						 var code = modal.find('#specialDisplay').text();
						 if(code != 'view') {
							 RVwys.insertHTML(code);
						 }
					 }
					 modal.hide();
					$(RVwys.currentIframe).focus();
				};
				var oncancel  = function(){
					modal.hide();
				};
				var options   = {
						bgclose:false, 
						keyboard:false, 
						modal:false
						};
				
				var modal = UI.modal.dialog(([
				                              '<div class="uk-margin uk-modal-header"><h2>'+rvLang('specialchar')+'</h2><span class="uk-modal-close uk-icon-close"></span></div>',
				                              '<div class="uk-margin uk-modal-content">'+spc.html()+'</div>',
				                              '<div class="uk-modal-footer uk-text-left clear"><br><button class="uk-button uk-button-success  js-modal-confirm">'+rvLang('Insert')+'</button>',
				                              '<button class="uk-button js-modal-confirm-cancel">'+rvLang('Cancel')+'</button></div>',
				                              ]).join(""), options);
				modal.element.find(".js-modal-confirm-cancel").on("click", function(){
					 oncancel();
					
				}).end().find(".uk-button-success").on("click", function(){
					onInsert();
					
				}).end().find('.specialcharBlockSize').on("mouseup", function(){
					RVwys.selectRange(cloneRange);
					$(RVwys.currentIframe).focus();
					modal.element.find('#specialDisplay').html($(this).html());
					modal.element.find('#spcCode').val($(this).attr('code'));
				})
				modal.show();

		 });
	 
		
		 
	 });
})(jQuery);